import type { OrganizationTreeOptions } from "@/modules/organization/organization-tree";

import { Card, Form, Spin } from "antd";
import { useTranslation } from "react-i18next";

import OrganizationSelect from "@/modules/organization/organization-select";
import OrganizationTree from "@/modules/organization/organization-tree";

import { useOrganizationTreeCard } from "./organization-tree-card.hook";

import "./organization-tree-card.style.less";

const OrganizationTreeCard = (options: OrganizationTreeOptions) => {
  const { t } = useTranslation();
  const { organization, isLoading, form, fieldName, onOrganizationChange } =
    useOrganizationTreeCard(options);

  return (
    <Card
      className="organization-tree-card"
      title={
        <Spin spinning={isLoading}>
          <Form form={form} layout="vertical">
            <OrganizationSelect
              name={fieldName}
              placeholder={t("global:filterByOrganization")}
              onOptionSelected={onOrganizationChange}
              allowClear={false}
              hideLabel
            />
          </Form>
        </Spin>
      }
    >
      <OrganizationTree organizationId={organization?.id} {...options} />
    </Card>
  );
};

export default OrganizationTreeCard;
